import React from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';

const KVKKPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-32 pb-24">
        <div className="max-w-[900px] mx-auto px-6">
          <h1 className="text-4xl font-bold text-[#0A1628] mb-8">
            KVKK Aydınlatma Metni
          </h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                1. Veri Sorumlusu
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca, kişisel verileriniz veri sorumlusu olarak tarafımızca aşağıda açıklanan kapsamda işlenebilecektir.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                2. Kişisel Verilerin İşlenme Amacı
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
              </p>
              <ul className="list-disc list-inside text-[#6B7A90] space-y-2 ml-4">
                <li>Hizmetlerimizin sunulması ve geliştirilmesi</li>
                <li>Müşteri ilişkileri yönetimi</li>
                <li>İletişim faaliyetlerinin yürütülmesi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                3. Kişisel Verilerin Aktarılması
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda iş ortaklarımıza, tedarikçilerimize ve yasal yükümlülüklerimiz gereği kamu kurum ve kuruluşlarına aktarılabilecektir.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                4. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Kişisel verileriniz, web sitemiz, e-posta, telefon ve diğer iletişim kanalları aracılığıyla sözlü, yazılı veya elektronik ortamda toplanmaktadır.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                5. Kişisel Veri Sahibinin Hakları
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside text-[#6B7A90] space-y-2 ml-4">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Kişisel verilerinizin yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                6. İletişim
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                KVKK kapsamındaki taleplerinizi aşağıdaki iletişim bilgilerinden bize iletebilirsiniz:
              </p>
              <p className="text-[#6B7A90] leading-relaxed">
                E-posta: kvkk@agency.com<br />
                Adres: Levent, İstanbul, Türkiye
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KVKKPage;